import { render, staticRenderFns } from "./gzfsq.vue?vue&type=template&id=80efd44e&scoped=true&"
import script from "./gzfsq.vue?vue&type=script&lang=js&"
export * from "./gzfsq.vue?vue&type=script&lang=js&"
import style0 from "./gzfsq.vue?vue&type=style&index=0&id=80efd44e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80efd44e",
  null
  
)

export default component.exports